import { render, staticRenderFns } from "./TagsWrapper.vue?vue&type=template&id=54d7af7e&lang=pug&"
import script from "./TagsWrapper.vue?vue&type=script&lang=js&"
export * from "./TagsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports